import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { LOGIN, ORDERS } from '../routes';
import { logout } from '../services/auth';
import { session } from '../services/session';
import branding from '../branding.svg';

class Header extends Component {
  constructor(props) {
    super(props);
    this.handleLogout = this.handleLogout.bind(this);
  }

  handleLogout(event) {
    event.preventDefault();
    logout()
      .then(() => this.props.history.push(LOGIN))
      .catch(message => window.alert(message));
  }

  render() {
    return (
      <nav className="mb-4">
        <Link className="navbar-brand" style={{ color: '#000' }} to={ORDERS}>
          <img
            src={branding}
            width="30"
            height="30"
            className="d-inline-block align-top mr-2"
            alt=""
          />
          Paperstac Audits
        </Link>
        {session.has('uid') && (
          <button
            className="btn btn-outline-danger float-right"
            onClick={this.handleLogout}
          >
            Logout
          </button>
        )}
        <hr />
      </nav>
    );
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js